import React, { SVGProps } from 'react';

const IcPartners = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#a)">
      <path d="M12 10.1H7c-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.3 3.2-3.3h5c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.3-3.2 3.3Zm-5-5c-1 0-1.8.8-1.8 1.8S6 8.6 7 8.6h5c1 0 1.8-.8 1.8-1.8S13 5.1 12 5.1H7ZM17 20.3h-5c-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.4-3.2 3.2-3.2h5c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2Zm-5-5c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h5c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8h-5Z" />
      <path d="M17 15.3c-1.8 0-3.2-1.4-3.2-3.2V6.9c0-1.8 1.4-3.2 3.2-3.2 1.8 0 3.2 1.4 3.2 3.2v5.2c0 1.8-1.4 3.2-3.2 3.2Zm0-10.2c-1 0-1.8.8-1.8 1.8v5.2c0 1 .8 1.7 1.8 1.7s1.8-.8 1.8-1.7V6.9c0-1-.8-1.8-1.8-1.8ZM7 20.2c-1.8 0-3.2-1.4-3.2-3.2v-5c0-1.8 1.4-3.2 3.2-3.2 1.8 0 3.2 1.4 3.2 3.2v5c0 1.7-1.4 3.2-3.2 3.2Zm0-10.1c-1 0-1.8.8-1.8 1.8v5c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-5c0-1-.8-1.8-1.8-1.8Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcPartners;
